let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5eF31")).then(() => parcelRequire('7fyIe'));